import { FC } from 'react'
import { IconProps } from '../../../LandingPage.icons'

const RoundedTriangle: FC<IconProps> = ({
  className = '',
  svgClassName = '',
  height = 91,
  width = 113,
}) => (
  <span aria-label="Rounded Triangle Icon" className={className} role="img">
    <svg
      className={svgClassName}
      fill="currentColor"
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M47.3514 4.12819L1.22959 78.1452C-2.23078 83.7104 2.02053 90.6669 8.89185 90.6669H103.657C110.627 90.6669 114.878 83.5249 111.22 77.9597L62.5277 3.94269C59.0179 -1.39062 50.713 -1.29787 47.3514 4.12819Z" />
    </svg>
  </span>
)

export default RoundedTriangle
